import React from 'react'

import Footer from '../components/Footer'
import '../assets/css/Home.css'
import Element from 'react-scroll/modules/components/Element'
import NewHero from '../components/NewHero'
import NewAbout from '../components/NewAbout'
import Divider from '../components/Divider'
import NewProjects from '../components/NewProjects'

export default function Home() {
  return (
    <>
    <Divider />
    <NewHero />
    <Divider />
    <Element name='About'>
    <NewAbout />
    </Element>
    <Divider />
    <Element name='Projects'>
    <NewProjects />
    </Element>
    <Divider />
    <Element name='Contact'>
    <Footer></Footer>
    </Element>
    </>
  )
}
